/* Sandbanks Saunas — scroll reveal */
(function () {
  if (window.__sbRevealInit) return;
  window.__sbRevealInit = true;

  function init() {
    var els = document.querySelectorAll('.sb-reveal:not(.sb-in)');
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('sb-in'); });
      return;
    }
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('sb-in');
            io.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15 }
    );
    els.forEach(function (el) { io.observe(el); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
